import {Field, mapField} from './field';

export class Element {

  constructor(public id: number,
              public kit_id: number,
              public name: string,
              public subtitle: string,
              public code: string = '',
              public description: string,
              public type_id: number,
              public genre_id: number,
              public video_preview: string,
              public thumbnail: string,
              public ord: number,
              public type: {id: number, name: string, created_at: string, updated_at: string},
              public genre: string,
              public fields: Field[],
              public folder_id: number|null,
              public metaFields = [],
              public updated_at: string,
              public created_at: string
  ) {}
}

export function mapElement(object: any, global_fields = [], kit_fields = []): Element {

  return new Element(
    object.id || null,
    object.kit_id || (object.kits && object.kits[0] ? object.kits[0].id : null),
    object.name || '',
    object.subtitle || '',
    object.code || '',
    object.description || '',
    object.type && object.type.id ? object.type.id : null,
    object.genre && object.genre.id ? object.genre.id : null,
    object.video_preview || '',
    object.thumbnail || '',
    object.ord || null,
    object.type || null,
    object.genre && object.genre.name ? object.genre.name : '',
    object.fields ? object.fields.map((field) => mapField(field)) : [],
    object.folder_id ? object.folder_id : null,
    [].concat(global_fields).concat(kit_fields),
    object.updated_at || new Date(),
    object.created_at || new Date()
  );
}


// WEBPACK FOOTER //
// ./src/app/services/element.ts